import { Edit } from 'react-admin'

import LandingPageForm from './LandingPageForm'

const LandingPageEdit = props => {
  return (
    <Edit undoable={false} {...props}>
      <LandingPageForm />
    </Edit>
  )
}

export default LandingPageEdit
